import React from "react";
import { Link } from "react-router-dom";
import { Sparkles } from "lucide-react";

/**
 * Phase 12 — Chat-first simplicity hint. One short line, muted colour, always
 * links to /ki-agent. Use at the top of a page or next to a primary action
 * where the agent can perform the same task via plain German.
 */
export default function ChatHint({ text, testid = "chat-hint" }) {
  return (
    <Link
      to="/ki-agent"
      data-testid={testid}
      className="group inline-flex items-center gap-2 text-xs text-slate-400 hover:text-emerald-300 transition"
    >
      <Sparkles className="h-3.5 w-3.5 text-emerald-400 group-hover:scale-110 transition" />
      <span>Tipp: {text}</span>
    </Link>
  );
}
